import { useMemo } from 'react';

function useRingColors() {
  const ringColors = useMemo(() => {
    return ['#e85b2a', '#f3c443', '#80e9e2', '#4fadc6', '#3270ca'];
  }, []);

  return { ringColors };
}

export default useRingColors;
